const NETWORK_FAILURE = /^TypeError: (Failed to fetch|Load failed|NetworkError|Network request failed)/i;

export default function isOfflineNetworkError(detail: unknown): boolean {
	if (!navigator.onLine) return true;
	return typeof detail === 'string' && NETWORK_FAILURE.test(detail);
}
